import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {useIntl} from 'react-intl';

import {Heading, Text} from '@edume/magnificent';

import styles from './styles.module.scss';

const getIntlMessage = (intl) => (id, values) =>
  intl.formatMessage({id}, values);

const SettingsCard = ({
  children,
  titleKey,
  descriptionKey,
  headerChildren,
  textStringValues,
  dataAutomation,
  noMarginTop,
}) => {
  const intlMessage = getIntlMessage(useIntl());

  const intl = useIntl();

  const defaultFormatting = {
    b: (chunk) => <b>{chunk}</b>,
  };

  const textValues = {...defaultFormatting, ...textStringValues};

  return (
    <div styleName='card' data-automation={dataAutomation}>
      {titleKey || headerChildren ? (
        <div styleName='card-header-container'>
          <div styleName='card-header'>
            {titleKey && (
              <Heading as='h2' size='cat' weight='semiBold'>
                {intlMessage(titleKey, textValues)}
              </Heading>
            )}
          </div>
          {headerChildren}
        </div>
      ) : null}
      {descriptionKey && (
        <div styleName='card-description'>
          <Text size='m'>
            {intl.formatMessage({id: descriptionKey}, textValues)}
          </Text>
        </div>
      )}
      <div styleName={classNames('container', {noMarginTop})}>{children}</div>
    </div>
  );
};

SettingsCard.propTypes = {
  titleKey: PropTypes.string,
  descriptionKey: PropTypes.string,
  children: PropTypes.any,
  headerChildren: PropTypes.node,
  textStringValues: PropTypes.objectOf(PropTypes.any),
  dataAutomation: PropTypes.string,
  noMarginTop: PropTypes.bool,
};

export default CSSModules(SettingsCard, styles, {allowMultiple: true});
